import IScroll from './iscroll';
let isTouch = is_touch_device();
$('.js-timeline').each(function() {
	let $c = $(this),
		$ctr = $c.find('.js-timeline-content'),
		id = $ctr.attr('id');
	let myScroll = new IScroll('#' + id, {
		mouseWheel: false,
		scrollX: true,
		scrollY: false,
		// scrollbars: true,
		// fadeScrollbars: true,
		scrollbars: 'custom',
		eventPassthrough: true,
		// preventDefault: false,
		disablePointer: isTouch, // important to disable the pointer events that causes the issues
		disableTouch: !isTouch, // false if you want the slider to be usable with touch devices
		disableMouse: !isTouch // false if you want the slider to be usable with a mouse (desktop)

	});
});

function is_touch_device() {
	var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
	var mq = function(query) {
		return window.matchMedia(query).matches;
	};

	if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
		return true;
	}

	// include the 'heartz' as a way to have a non matching MQ to help terminate the join
	// https://git.io/vznFH
	var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
	return mq(query);
}

